import { formatCalendarDate } from "../time";

export function SchoolDateContext({ date, timeZone }: { date: string; timeZone: string }) {
  return <div className="create-class-context">
    <strong>School date: {formatCalendarDate(date)}</strong>
    <span>{timeZone}</span>
  </div>;
}
